"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[454],{

/***/ 9454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Locations; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(6734);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(1776);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(4078);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/BookNow/BookNow.tsx
var BookNow = __webpack_require__(6562);
// EXTERNAL MODULE: ./components/Cards/Card.tsx
var Card = __webpack_require__(2132);
// EXTERNAL MODULE: ./hooks/useFetch.ts + 1 modules
var useFetch = __webpack_require__(9350);
;// CONCATENATED MODULE: ./components/Locations/Location.card.tsx





const LocationCard = (param)=>{
    let { title , id , address , phoneNumber , countryCode , formattedNumber  } = param;
    const { data: businessProfile  } = (0,useFetch/* useBusinessProfile */.jB)();
    const widgetSetting = businessProfile === null || businessProfile === void 0 ? void 0 : businessProfile.data.widget;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex gap-4 items-center flex-col md:flex-row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full md:w-auto flex-auto",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "font-medium text-base mb-4",
                            children: title
                        }),
                        address && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "font-base text-sm break-word",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "text-[#46474a] hover:text-zinc-800 hover:underline",
                                href: "https://www.google.com/maps/?q=".concat(address),
                                target: "_blank",
                                rel: "noreferrer",
                                children: address
                            })
                        }),
                        phoneNumber && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "font-base text-sm text-[#46474a] break-word mt-1",
                            children: [
                                "+",
                                countryCode,
                                " ",
                                formattedNumber
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full md:w-auto flex-none flex flex-col space-y-4 justify-end md:pl-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BookNow/* default */.Z, {
                        uniqueIdentifier: widgetSetting === null || widgetSetting === void 0 ? void 0 : widgetSetting.uniqueIdentifier,
                        type: "location",
                        id: id,
                        buttonWide: true
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Location_card = (/*#__PURE__*/(0,react.memo)(LocationCard));

;// CONCATENATED MODULE: ./components/About/Locations.about.tsx




const Map = dynamic_default()(()=>__webpack_require__.e(/* import() */ 795).then(__webpack_require__.bind(__webpack_require__, 4795)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(4795)
            ]
    },
    ssr: false
});
function Locations(param) {
    let { locations  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Map, {
                locations: locations.items
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "space-y-3 mt-4",
                children: locations.items.map((location)=>{
                    var _location_phone, _location_phone1, _location_phone2;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Location_card, {
                        id: location.id,
                        title: location.name,
                        address: location.address.displayAddress,
                        phoneNumber: location === null || location === void 0 ? void 0 : (_location_phone = location.phone) === null || _location_phone === void 0 ? void 0 : _location_phone.number,
                        countryCode: location === null || location === void 0 ? void 0 : (_location_phone1 = location.phone) === null || _location_phone1 === void 0 ? void 0 : _location_phone1.countryCode,
                        formattedNumber: location === null || location === void 0 ? void 0 : (_location_phone2 = location.phone) === null || _location_phone2 === void 0 ? void 0 : _location_phone2.formattedNumber
                    }, location.id);
                })
            })
        ]
    });
}


/***/ }),

/***/ 6562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1776);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3906);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8757);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7280);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1689);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var utils_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8728);







function BookNow(param) {
    let { uniqueIdentifier , type , id , buttonWide , hasLongTitle  } = param;
    const { locale  } = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const { t  } = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("common");
    if (!uniqueIdentifier) return null;
    const href = (0,utils_utils__WEBPACK_IMPORTED_MODULE_6__/* .generateBookingURL */ ._2)({
        uniqueIdentifier,
        type,
        id,
        locale
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
        href: href,
        className: classnames__WEBPACK_IMPORTED_MODULE_4___default()("flex items-center justify-center border border-primary-500 text-sm rounded-lg text-primary-text bg-primary-500 uppercase font-medium hover:bg-primary-300 hover:border-primary-300 transition-colors cursor-pointer", {
            "py-2 px-8": buttonWide
        }, {
            "py-3 px-5": !buttonWide
        }),
        children: hasLongTitle && t("global.booknow") || t("global.book")
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(BookNow));


/***/ }),

/***/ 2132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1776);


function Card(param) {
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "relative p-4 rounded-lg border border-zinc-200",
        children: children
    });
}


/***/ })

}]);